import { i18n } from "@src/i18n/i18n";
import store from "@src/reducers/store";
import { ZitadelServiceUser, ZitadelUser } from "@src/types/user-management";

type UserDrawerInputField =
  | "username"
  | "given_name"
  | "family_name"
  | "email"
  | "name"
  | "description"
  | "expiration_date";

export const validateUserInputs = (
  user: Partial<ZitadelUser | ZitadelServiceUser> | null,
): { isValid: boolean; errors: string[] } => {
  const language = store.getState().yourSlice.language;

  const FIELD_LABELS: Record<UserDrawerInputField, string> = {
    username: i18n("modules.validateUserDrawerInputsUtil.username", language),
    given_name: i18n(
      "modules.validateUserDrawerInputsUtil.given_name",
      language,
    ),
    family_name: i18n(
      "modules.validateUserDrawerInputsUtil.family_name",
      language,
    ),
    email: i18n("modules.validateUserDrawerInputsUtil.email", language),
    name: i18n("modules.validateUserDrawerInputsUtil.name", language),
    expiration_date: i18n(
      "modules.validateUserDrawerInputsUtil.expiration_date",
      language,
    ),
    description: i18n(
      "modules.validateUserDrawerInputsUtil.description",
      language,
    ),
  };

  if (!user) {
    return {
      isValid: false,
      errors: ["User data is missing"],
    };
  }

  const fieldsToCheck: UserDrawerInputField[] =
    user.type === "HUMAN"
      ? ["username", "given_name", "family_name", "email"]
      : ["username", "name", "description", "expiration_date"];

  const errors: string[] = [];

  fieldsToCheck.forEach((field) => {
    if (!user[field]) {
      errors.push(FIELD_LABELS[field]);
    }
  });

  if (user.type === "HUMAN" && user.email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(user.email)) {
      errors.push(`${FIELD_LABELS.email} (invalid format)`);
    }
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};
